/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Event } from './Event';
import {
    EventFromJSON,
    EventFromJSONTyped,
    EventToJSON,
} from './Event';
import type { RemixContestsRelated } from './RemixContestsRelated';
import {
    RemixContestsRelatedFromJSON,
    RemixContestsRelatedFromJSONTyped,
    RemixContestsRelatedToJSON,
} from './RemixContestsRelated';

/**
 *
 * @export
 * @interface EventsResponse
 */
export interface EventsResponse {
    /**
     *
     * @type {Array<Event>}
     * @memberof EventsResponse
     */
    data?: Array<Event>;
    /**
     *
     * @type {RemixContestsRelated}
     * @memberof EventsResponse
     */
    related?: RemixContestsRelated;
}

/**
 * Check if a given object implements the EventsResponse interface.
 */
export function instanceOfEventsResponse(value: object): value is EventsResponse {
    let isInstance = true;

    return isInstance;
}

export function EventsResponseFromJSON(json: any): EventsResponse {
    return EventsResponseFromJSONTyped(json, false);
}

export function EventsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(EventFromJSON)),
        'related': !exists(json, 'related') ? undefined : RemixContestsRelatedFromJSON(json['related']),
    };
}

export function EventsResponseToJSON(value?: EventsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(EventToJSON)),
        'related': RemixContestsRelatedToJSON(value.related),
    };
}
